import React, { Dispatch, SetStateAction, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import InsightFiltersViewModel from "./ViewModels/InsightFiltersViewModel";

interface IInsightTablePaginationBarProps {
    pageNumber: number
    pageNumberCount: number
    resultsCount: number
    filters: InsightFiltersViewModel
    setFilters: Dispatch<SetStateAction<InsightFiltersViewModel>>
    responseSearch: (newFilters: InsightFiltersViewModel) => void
}

const isInteger = (str) => {
    return /^-?\d+$/.test(str);
}

export default function InsightTablePaginationBar({ pageNumber, pageNumberCount, resultsCount, setFilters, filters, responseSearch }: IInsightTablePaginationBarProps) {
    const [customPageNumber, setCustomPageNumber] = useState<number>(pageNumber);

    useEffect(() => {
        setCustomPageNumber(pageNumber)
    }, [pageNumber])

    const onPageChange = (pageNumber: number) => {
        const newFilters = { ...filters, pageNumber: pageNumber };
        setFilters({ ...newFilters })
        responseSearch(newFilters);
    }

    const onCustomPageNumberChange = (event: any) => {
        const newPageNumber = event.target.value;
        if (!isNaN(newPageNumber) && isInteger(newPageNumber)) {
            if (newPageNumber > 0 && newPageNumber <= pageNumberCount)
                setCustomPageNumber(newPageNumber);
        }
    }

    return (
        <>
            <Grid container padding={1} justifyContent='space-between' alignItems='flex-end' sx={{ height: '9%' }}>
                <Grid size={10}>
                    <Button
                        variant='contained'
                        color='primary'
                        disabled={pageNumber === 1}
                        onClick={() => onPageChange(--pageNumber)}>
                        Previous Page
                    </Button>
                    <Button
                        variant='contained'
                        color='primary'
                        disabled={pageNumber === pageNumberCount}
                        onClick={() => onPageChange(++pageNumber)}
                        sx={{ ml: 2 }}>
                        Next Page
                    </Button>
                    <TextField
                        value={customPageNumber}
                        onChange={onCustomPageNumberChange}
                        margin="none"
                        size="small"
                        sx={{ width: '75px', ml: 2, mr: 2 }}
                    />
                    <label>{`of ${pageNumberCount}`}</label>
                    <Button
                        variant='contained'
                        onClick={() => onPageChange(customPageNumber)}
                        color='secondary'
                        sx={{ ml: 1 }}>
                        Apply
                    </Button>
                </Grid>
                <Grid container justifyContent='flex-end' alignItems='center' size={2}>
                    <Grid>
                        {`${resultsCount} results found`}
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};
